import styled from "styled-components";

export const ClickableText = styled.text`
  cursor: pointer;
`;
